import { render, staticRenderFns } from "./MemberCod.vue?vue&type=template&id=10d0f31e"
import script from "./MemberCod.vue?vue&type=script&lang=js"
export * from "./MemberCod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports